export class CustomerDeviceType {
  static get Continue () {
    return 1
  }
  static get Repurchase () {
    return 2
  }
  static get None () {
    return 3
  }

  static CustomerDeviceTypeName (CustomerDeviceType) {
    let tmpType = parseInt(CustomerDeviceType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '原廠設備沿用'
        break
      case 2:
        name = '原廠設備買回'
        break
      case 3:
        name = '客戶已付費設備'
        break
    }
    return name
  }
}
